import ArrowRightSvg from '../../images/icons/arrow-right.svg';
import RainbowLink from '../RainbowLink/RainbowLink';
import { whiteToDefaultLink } from './animations';

type Props = {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
};

const BannerCTA = ({ children, onClick, href }: Props) => {
  return (
    <span
      style={{
        animation: whiteToDefaultLink,
      }}
    >
      <RainbowLink
        className="whitespace-nowrap text-unset"
        href={href}
        onClick={onClick}
      >
        {children}
        <ArrowRightSvg className="ml-2 inline-block size-3" />
      </RainbowLink>
    </span>
  );
};

export default BannerCTA;
